var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0029 11.999L29.8516 15.999L20.0029 19.999L16.0029 29.8477L12.0029 19.999L2.1543 15.999L12.0029 11.999L16.0029 2.15039L20.0029 11.999ZM7.40234 4.59863L10.6689 5.99902L7.40234 7.39844L6.00293 10.665L4.60254 7.39844L1.33594 5.99902L4.60254 4.59863L6.00293 1.33203L7.40234 4.59863Z",
    fill: "url(#paint0_linear_10601_306327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10601_306327",
    x1: 15.5938,
    y1: 1.33203,
    x2: 15.5938,
    y2: 29.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#853CE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E01D5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBubble);
export default __webpack_public_path__ + "static/media/ai-bubble.525be69701f9b78a47d92c6b43175db1.svg";
export { ForwardRef as ReactComponent };